import { isMobileViewportWidth } from './breakpoints';

// The nearest ancestor that actually scrolls (the cart sheet's product list,
// a modal body …), or null when the page itself is the scroller.
const scrollParentOf = (el: HTMLElement): HTMLElement | null => {
  let node = el.parentElement;
  while (node && node !== document.body) {
    const { overflowY } = window.getComputedStyle(node);
    if (
      (overflowY === 'auto' || overflowY === 'scroll') &&
      node.scrollHeight > node.clientHeight
    ) {
      return node;
    }
    node = node.parentElement;
  }
  return null;
};

/**
 * Phones: bring a just-focused field (or the block around it) to the top of
 * the area it scrolls in while the on-screen keyboard slides up. Inside a
 * sheet only that sheet's own scroller moves — never the page, which iOS is
 * busy panning for the keyboard at the same moment — so the field ends up in
 * the part of the sheet the keyboard leaves visible (the sheet itself sits
 * on the keyboard: shared mobile-keyboard). Runs on the next frame (after
 * focus-driven layout changes) and again as the keyboard settles (iOS
 * animates it in over ~300ms). No-op on wider screens.
 */
const revealOnKeyboard = (target: HTMLElement | null) => {
  if (!target || !isMobileViewportWidth(window.innerWidth)) return;

  const reveal = () => {
    if (!target.isConnected) return;
    const box = scrollParentOf(target);
    if (!box) {
      target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }
    const offset =
      target.getBoundingClientRect().top - box.getBoundingClientRect().top;
    box.scrollTo({
      top: Math.max(0, box.scrollTop + offset - 8),
      behavior: 'smooth',
    });
  };

  window.requestAnimationFrame(reveal);
  window.setTimeout(reveal, 350);
  window.setTimeout(reveal, 700);
};

export default revealOnKeyboard;
